import {axios, HOST, config} from './settiing';

export default {
  addFareList(data) {
    return axios.post(`${HOST}/resource/fare`, data, config)
  },

  updateFareList(data) {
    return axios.put(`${HOST}/resource/fare`, data, config)
  },

  getFareList(centerId) {
    return axios.get(`${HOST}/resource/fare/${centerId}`, config);
  },

  getFareInfoList(centerId) {
    return axios.get(`${HOST}/resource/fareInfo/${centerId}`, config);
  },

  saveFareInfoList(data) {
    return axios.post(`${HOST}/resource/fareInfo`, data, config)

  },
  getSuburbanAreaFares(centerId, fareType) {
    return axios.get(`${HOST}/resource/fare/suburbanArea/${centerId}/${fareType}`, config)
  },
}